<div class="widget-header flex flex-row place-content-between items-center mb-5">
  <h1 class="text-2xl font-medium" i18n>Your professional information</h1>
  <button mat-icon-button i18n-matTooltip matTooltip="Edit professional information">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
  </button>
</div>
